import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=1bee2d4c&scoped=true"
import script from "./merchant.js?vue&type=script&lang=js&external"
export * from "./merchant.js?vue&type=script&lang=js&external"
import style0 from "./merchant.scss?vue&type=style&index=0&id=1bee2d4c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee2d4c",
  null
  
)

export default component.exports